export const claimsServiceLineHistoryColumns = [
  'id',
  'fk_claim_id',
  'fk_claims_meta_data_id',
  'fk_billing_provider_id',
  'fk_subscriber_id',
  'claim_number',
  'service_line_period_id',
  'service_line_period_type',
  'service_line_period',
  'service_line_revenue_code',
  'service_line_procedure_code',
  'service_line_amount',
  'service_line_unit_description',
  'service_line_unit_count',
  'service_line_hcpcs',
  'service_line_hcpcs_modifier',
  'service_line_sv_102',
  'service_line_sv_103',
  'service_line_sv_104',
  'service_line_sv_105_amount',
  'service_line_sv_106',
  'service_line_sv_107',
  'drug_code',
  'drug_code_type',
  'delimiter',
  'trx_key',
  'meta_lineage_source_system_name',
  'meta_lineage_source_name',
  'meta_lineage_source_offset',
  'meta_load_dt',
  'meta_correlation_id',
  'meta_component',
  'snapshot_id',
  'meta_lineage_content_hash',
];
